"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentServiceStub = void 0;
const faker_1 = __importDefault(require("faker"));
class PaymentServiceStub {
    getPlanInfo(planName) {
        return __awaiter(this, void 0, void 0, function* () {
            if (planName) {
                const pricePlanInfo = {
                    id: `price_${faker_1.default.random.alphaNumeric()}`,
                    productId: `product_${faker_1.default.random.alphaNumeric()}`,
                    productName: faker_1.default.random.word(),
                    recurringInterval: "month",
                    recurringIntervalCount: 1,
                    trialPeriodDays: faker_1.default.random.number(30),
                    amount: faker_1.default.random.number(),
                    type: "recurring",
                };
                return { status: true, message: "Plan info", payload: pricePlanInfo };
            }
            return { status: false, message: "Failed to get plan info", payload: null };
        });
    }
    getSubscriptionPlans() {
        return __awaiter(this, void 0, void 0, function* () {
            const pricePlanInfo = {
                id: `price_${faker_1.default.random.alphaNumeric()}`,
                productId: `product_${faker_1.default.random.alphaNumeric()}`,
                productName: faker_1.default.random.word(),
                recurringInterval: "month",
                recurringIntervalCount: 1,
                trialPeriodDays: faker_1.default.random.number(30),
                amount: faker_1.default.random.number(),
                type: "recurring",
            };
            return { status: true, message: "Plan info", payload: [pricePlanInfo] };
        });
    }
}
exports.PaymentServiceStub = PaymentServiceStub;
//# sourceMappingURL=PaymentServiceStub.js.map